import { serverApi } from '../api';

// ---------------------------------------------------------------------------
// Normalización de listas de medios para las pantallas (CallScreen,
// CallScreenV2, Cola2). El reproductor (components/videoPlayer3.js) entiende:
//   JSON de items -> { tipoMedia: 'youtube'|'video'|'imagen', valor, duracionSeg, titulo }
//
// Este helper acepta las distintas formas que devuelve el backend:
//  - Filas de videosListas: { videoCodigo, videoTitulo, tipoMedia, duracionSeg }
//  - Lista legada de la entidad: [{ code }] o ["idYoutube", ...]
//  - String ya normalizado (se devuelve tal cual)
// ---------------------------------------------------------------------------

const EXT_IMAGEN = /\.(png|jpe?g|webp|gif|svg|avif|bmp)(\?.*)?$/i;
const EXT_VIDEO = /\.(mp4|webm|ogg|ogv|mov|m4v|mkv)(\?.*)?$/i;

const detectarTipo = (valor) => {
    const v = String(valor || '').trim();
    if (!v) return 'youtube';
    if (EXT_IMAGEN.test(v)) return 'imagen';
    if (EXT_VIDEO.test(v)) return 'video';
    if (/^https?:\/\//i.test(v)) return 'video';
    return 'youtube';
};

export const parseVideosLista = (videosRaw) => {
    try {
        if (!videosRaw) return '';

        // Ya viene como JSON normalizado (string que empieza con '[')
        if (typeof videosRaw === 'string' && videosRaw.trim().startsWith('[')) {
            return videosRaw;
        }

        const parsed = typeof videosRaw === 'string' ? JSON.parse(videosRaw) : videosRaw;
        if (!Array.isArray(parsed)) return '';

        const items = parsed
            .map((v) => {
                if (v && typeof v === 'object') {
                    const valor = v.videoCodigo ?? v.valor ?? v.code ?? '';
                    return {
                        tipoMedia: v.tipoMedia || detectarTipo(valor),
                        valor,
                        duracionSeg: Number(v.duracionSeg) > 0 ? Number(v.duracionSeg) : 10,
                        titulo: v.videoTitulo ?? v.titulo ?? '',
                    };
                }

                const valor = String(v || '').trim();
                return { tipoMedia: detectarTipo(valor), valor, duracionSeg: 10, titulo: '' };
            })
            .filter((it) => it.valor);

        return JSON.stringify(items);
    } catch (e) {
        console.error('Error parseando videos:', e);
        return '';
    }
};

// Resuelve la URL absoluta de un medio (las subidas se guardan como ruta
// relativa /videos/archivo.ext). Las URLs absolutas y data: se devuelven igual.
export const urlMedia = (ruta) => {
    if (!ruta) return '';
    if (/^https?:\/\//i.test(ruta) || String(ruta).startsWith('data:')) return ruta;
    const base = (serverApi.defaults.baseURL || '').replace('/api', '');
    return `${base}${ruta}`;
};
